/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Check_Link_Try_AgainInputs */

const en_mobile_check_link_try_again = /** @type {(inputs: Mobile_Check_Link_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the link and try again.`)
};

const es_mobile_check_link_try_again = /** @type {(inputs: Mobile_Check_Link_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa el enlace e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Check the link and try again." |
*
* @param {Mobile_Check_Link_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_check_link_try_again = /** @type {((inputs?: Mobile_Check_Link_Try_AgainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Check_Link_Try_AgainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_check_link_try_again(inputs)
	return en_mobile_check_link_try_again(inputs)
});